export const graphInfo = {
  docType: {
    labels: [],
    datasets: [],
  },
  docStatus: {
    labels: [],
    datasets: [],
  },
  system: {
    labels: [],
    datasets: [],
  },
} as any;
